import type { Icon } from '../../../src/lib/types'
export const mdiAlertOctagon: Icon = {
  "id": "alert-octagon",
  "name": "Alert Octagon",
  "path": "M13 13H11V7H13M11 15H13V17H11M15.73 3H8.27L3 8.27V15.73L8.27 21H15.73L21 15.73V8.27L15.73 3Z",
  "as": [
    "warning-octagon",
    "report",
    "stop-alert"
  ],
  "tags": [
    "Alert / Error"
  ]
}
export default mdiAlertOctagon